// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"f7548355","831":"60173552"}[chunkId] + ".chunk.js";
};